module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.list && _vm.list.length) ? _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        'selected': String(item.id) === _vm.curValue,
          'disabled': !_vm.isEnabled(item),
          'can-copy': _vm.canCopyToDc(item)
      },
      attrs: {
        "title": _vm.generateTitle(item)
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": _vm.mouseLeave,
        "click": function($event) {
          return _vm.onItemClick(item)
        }
      }
    }, [(item['image'] && item['image'].length) ? _c('div', {
      staticClass: "left-part"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + item['image']
      }
    })]) : _c('div', {
      staticClass: "left-part clmn"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hdd"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [(item['name']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v("#" + _vm._s(item['id']) + " " + _vm._s(_vm._f("ftc")(item['name'])))]) : _vm._e(), _vm._v(" "), (item['size'] || item['created']) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.countryOfDc(item)) ? _c('span', {
      staticClass: "flag-icon",
      class: 'flag-icon-' + _vm.countryOfDc(item).country,
      staticStyle: {
        "width": "12px",
        "top": "-1px",
        "margin-right": "3px"
      },
      attrs: {
        "alt": _vm._f("ftc")(_vm.countryOfDc(item).name),
        "title": _vm._f("ftc")(_vm.countryOfDc(item).name)
      }
    }) : _vm._e(), _vm._v(" "), (item['size']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('service/iso_size')) + ": " + _vm._s(item['size']))]) : _vm._e(), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(", ")]) : _vm._e(), _vm._v(" "), (item['created']) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")('main/created')) + ": " + _vm._s(_vm._f("date")(item['created'], 'd.m.Y')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showedTopHintId === item.id),
        expression: "showedTopHintId === item.id"
      }],
      staticClass: "top-hint"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.makeReason(item)),
        expression: "makeReason(item)"
      }]
    })]), _vm._v(" "), (_vm.canCopyToDc(item)) ? _c('font-awesome-icon', {
      staticClass: "copy-to-dc-btn",
      attrs: {
        "icon": "share",
        "title": _vm.localeFtc('backup/copy')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goToBackupsForCopy(item)
        }
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f404dfe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/backup.vue
// module id = 380
// module chunks = 0